module.exports = __webpack_public_path__ + "img/banner.38b3ff32.jpg";